import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={33}
    height={21}
    viewBox="0 0 33 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.4011 12.1642L15.4601 10.1487L10.6089 0.993033C10.404 0.617229 9.99412 0.446372 9.61833 0.514765C7.09022 0.856491 5.68972 2.08638 4.4598 3.21351C3.40081 4.17007 2.4099 5.05818 0.736106 5.46832C0.462773 5.53671 0.223761 5.74165 0.0869505 6.01498C-0.0495973 6.28831 -0.0155196 6.59572 0.121028 6.83495L3.53731 13.3942C3.74225 13.77 4.15212 13.975 4.5963 13.8725C6.74862 13.3601 8.04669 12.1984 9.17406 11.1737C10.2331 10.2172 11.1555 9.39721 12.7269 9.05571L14.4011 12.1642Z"
      fill={color}
    />
    <path
      d="M17.9545 14.8281L16.8955 16.8437L18.5353 19.9526C18.7061 20.26 19.0476 20.4649 19.3893 20.4649C19.5259 20.4649 19.6967 20.4308 19.8335 20.3624C20.2777 20.1232 20.4827 19.5425 20.2093 19.0642L17.9545 14.8281Z"
      fill={color}
    />
    <path
      d="M32.3365 6.01528C32.1999 5.74195 31.9607 5.53701 31.6873 5.46862C29.9792 5.05874 28.9886 4.17037 27.9636 3.21381C26.7338 2.08644 25.333 0.856514 22.8392 0.515069H22.8051C22.3952 0.446676 21.9852 0.651616 21.8145 0.993336L12.1464 19.0997C11.9072 19.5779 12.078 20.1246 12.5222 20.3979C12.6588 20.4663 12.8297 20.5004 12.9664 20.5004C13.3082 20.5004 13.6496 20.3295 13.7864 19.988L19.594 9.05591C21.1656 9.39764 22.0879 10.2517 23.1468 11.1739C24.2742 12.1989 25.5382 13.3604 27.7246 13.8727C28.1345 13.9752 28.5787 13.7702 28.7836 13.3944L32.2683 6.83516C32.4389 6.5959 32.4389 6.28849 32.3364 6.01519L32.3365 6.01528Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
